import Component from '../abstracts/Component';
import LookbookSubComponent from './LookbookSubComponent';

export default class LookbookComponent extends Component {
  get SELECTORS() {
    return {
      lookbookVetrinaItems: '.w-lookbook-vetrina__media-wrapper',
      lookbookGalleryItems: '.w-lookbook-gallery',
      lookbookFullImageItems: '.w-lookbook-full-image'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.lookbookVetrinaItems = this.$component.querySelectorAll(this.SELECTORS.lookbookVetrinaItems);
    this.lookbookGalleryItems = this.$component.querySelectorAll(this.SELECTORS.lookbookGalleryItems);
    this.lookbookFullImageItems = this.$component.querySelectorAll(this.SELECTORS.lookbookFullImageItems);
  }
  
  render() {
    if (this.lookbookVetrinaItems && this.lookbookVetrinaItems.length) {
      this.lookbookVetrinaItems.forEach(vetrinaItem => {
        let component = new LookbookSubComponent(vetrinaItem);
        component.render();
      });
    }
    if (this.lookbookGalleryItems && this.lookbookGalleryItems.length) {
      this.lookbookGalleryItems.forEach(galleryItem => {
        let component = new LookbookSubComponent(galleryItem);
        component.render();
      });
    }
    if (this.lookbookFullImageItems && this.lookbookFullImageItems.length) {
      this.lookbookFullImageItems.forEach(fullImageItem => {
        let component = new LookbookSubComponent(fullImageItem);
        component.render();
      });
    }
  }
}
